export default function NavbarSearchIconActive({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M439.03,400.57l-86.93-86.93c22.41-29.16,34.59-64.78,34.59-101.88,0-92.41-75.18-167.6-167.6-167.6S51.49,119.35,51.49,211.76s75.18,167.6,167.6,167.6c29.91,0,58.8-7.85,84.34-22.81l89.8,89.8c6.11,6.12,14.25,9.49,22.9,9.49s16.78-3.37,22.89-9.48c12.62-12.62,12.62-33.16,0-45.79ZM219.09,108.92c56.71,0,102.84,46.13,102.84,102.84s-46.14,102.84-102.84,102.84-102.84-46.13-102.84-102.84,46.13-102.84,102.84-102.84Z" />
    </svg>
  );
}
